import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CompanyState {
  id: any;
  accountManagerId?: any;
  companyGroupId?: any;
  enumCompanyRankId?: any;
  type?: any;
  name?: any;
  country?: any;
  locality?: any;
  address?: any;
  phone?: any[];
  email?: any[];
  bankAccount?: any;
  bank?: any;
  cnp?: any;
  signature?: any;
  cui?: any;
  registrationNumber?: any;
  activityDescription?: any;
  leadership?: any;
  webAddress?: any;
  accountManager?: any;
  companyGroup?: any;
  enumCompanyRank?: any;
  contactPersons?: any;
  props: {
    [key: string]: any;
  };
}

const initialState: CompanyState = {
  id: '',
  accountManagerId: '',
  companyGroupId: '',
  enumCompanyRankId: null,
  type: '',
  name: '',
  country: '',
  locality: '',
  address: '',
  phone: [],
  email: [],
  bankAccount: '',
  bank: '',
  cnp: 0,
  signature: '',
  cui: '',
  registrationNumber: '',
  activityDescription: '',
  leadership: '',
  webAddress: '',
  accountManager: {},
  companyGroup: {},
  enumCompanyRank: {},
  contactPersons: [],
  props: { isModalVisible: false, refresh: false, searchTerm: '', skip: 1, take: 10, totalItems: 0 },
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompany: (state, action: PayloadAction<Partial<CompanyState>>) => {
      return { ...state, ...action.payload };
    },

    resetProps: (_state, action: PayloadAction<Partial<CompanyState['props']> | undefined>) => {
      return {
        ...initialState,
        props: { ...initialState.props, ...action.payload },
      };
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },

    updateField: (state: CompanyState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },

    addContactPerson: (state, action) => {
      state.contactPersons.push(action.payload);
    },

    updateContactPerson: (state, action: PayloadAction<{ index: number; updates: any }>) => {
      const { index, updates } = action.payload;
      if (state.contactPersons[index]) {
        state.contactPersons[index] = {
          ...state.contactPersons[index],
          ...updates,
        };
      }
    },

    removeContactPerson: (state, action: PayloadAction<number>) => {
      if (state.contactPersons) {
        state.contactPersons.splice(action.payload, 1);
      }
    },
  },
});

export const {
  setCompany,
  resetProps,
  updateProps,
  updateField,
  addContactPerson,
  updateContactPerson,
  removeContactPerson,
} = companySlice.actions;

export default companySlice.reducer;
